var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 0H5.5C2.46675 0 0 2.46675 0 5.5V17.4167C0 17.6598 0.0965771 17.8929 0.268485 18.0648C0.440394 18.2368 0.673552 18.3333 0.916667 18.3333H12.8333C15.8666 18.3333 18.3333 15.8666 18.3333 12.8333V5.5C18.3333 2.46675 15.8666 0 12.8333 0ZM6.41575 13.75H4.58333V11.9176L9.6525 6.85575L11.4849 8.68817L6.41575 13.75ZM12.3493 7.82375L10.5169 5.99133L11.9139 4.59525L13.7463 6.42767L12.3493 7.82375V7.82375Z",
    fill: "#DEDADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3be60effb2d7001574ecfb484535648a.svg";
export { ForwardRef as ReactComponent };